import  { useState } from 'react'
import styled from 'styled-components'
import Title from '../../components/Title/Title'
import Description from '../../components/Description/Description'
import Box from '../../components/Box/Box'
import arrowDown from '../../images/icons/arrow-down.svg'
import arrowUp from '../../images/icons/arrow-up.svg'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`
const Grid1 = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 50px;
  width: 100%;
`
const Grid2 = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 50px;
  align-items: baseline;
`
const BoxWrapper = styled.div`
  display: grid;
  grid-gap: 25px;
  position: relative;
`
const BoxTitle = styled.h2`
  margin: 0;
  text-align: left;
`
const BoxDescription = styled.p`
  margin: 0;
  text-align: left;
`
const Icon = styled.img`
  position: absolute;
  right: 0;
  cursor: pointer;
`

export default function FAQ() {
  const [openFirst, setOpenFirst] = useState<boolean>(false)
  const [openSecond, setOpenSecond] = useState<boolean>(false)
  const [openThird, setOpenThird] = useState<boolean>(false)
  const [openFourth, setOpenFourth] = useState<boolean>(false)

  return (
    <Container>
      <div className="container">
        <Wrapper>
          <Grid1>
            <Title title="FAQ" />
            <Description description="Most asked questions about GDark are here!" />
            <Grid2 className="faq__grid2">
              <Box>
                <BoxWrapper>
                  <BoxTitle>Is it free?</BoxTitle>
                  {openFirst && (
                    <BoxDescription>
                      Yes, GDark is entirely free to use.
                    </BoxDescription>
                  )}
                  {openFirst ? (
                    <Icon
                      src={arrowUp}
                      alt="Close"
                      onClick={() => setOpenFirst(false)}
                    />
                  ) : (
                    <Icon
                      src={arrowDown}
                      alt="Open"
                      onClick={() => setOpenFirst(true)}
                    />
                  )}
                </BoxWrapper>
              </Box>
              <Box>
                <BoxWrapper>
                  <BoxTitle>Can GDark see my data?</BoxTitle>
                  {openSecond && (
                    <BoxDescription>
                      No, GDark cannot read, update, or delete any of
                      your data. Just to be sure, you can see the source code.
                    </BoxDescription>
                  )}
                  {openSecond ? (
                    <Icon
                      src={arrowUp}
                      alt="Close"
                      onClick={() => setOpenSecond(false)}
                    />
                  ) : (
                    <Icon
                      src={arrowDown}
                      alt="Open"
                      onClick={() => setOpenSecond(true)}
                    />
                  )}
                </BoxWrapper>
              </Box>
              <Box>
                <BoxWrapper>
                  <BoxTitle>Does it work on Safari?</BoxTitle>
                  {openThird && (
                    <BoxDescription>
                      No, GDark doesn't currently work on Safari.
                    </BoxDescription>
                  )}
                  {openThird ? (
                    <Icon
                      src={arrowUp}
                      alt="Close"
                      onClick={() => setOpenThird(false)}
                    />
                  ) : (
                    <Icon
                      src={arrowDown}
                      alt="Open"
                      onClick={() => setOpenThird(true)}
                    />
                  )}
                </BoxWrapper>
              </Box>
              <Box>
                <BoxWrapper>
                  <BoxTitle>Why it doesn't work?</BoxTitle>
                  {openFourth && (
                    <BoxDescription>
                      If the GDark browser extension doesn't work
                      (Editor/Dashboard theme is still white, something isn't
                      dark as expected), just submit an issue.
                    </BoxDescription>
                  )}
                  {openFourth ? (
                    <Icon
                      src={arrowUp}
                      alt="Close"
                      onClick={() => setOpenFourth(false)}
                    />
                  ) : (
                    <Icon
                      src={arrowDown}
                      alt="Open"
                      onClick={() => setOpenFourth(true)}
                    />
                  )}
                </BoxWrapper>
              </Box>
            </Grid2>
          </Grid1>
        </Wrapper>
      </div>
    </Container>
  )
}
